import React from "react";
import { Link } from "react-router-dom";
import { faCaretSquareRight } from "@fortawesome/free-regular-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type CardLinkProps = {
    card: any;
};

function CardLink({ card }: CardLinkProps) {
    if (!card._id) {
        return <div></div>;
    }

    console.log(card);
    return (
        <Link to={card.link}>
            {/* <FontAwesomeIcon icon={faCaretSquareRight} /> */}
            <span className="lnr-small lnr lnr-link"></span>{" "}
        </Link>
    );
}
export default CardLink;
